import PropTypes from 'prop-types'
import { Alert, Card, Flex, Typography } from 'antd'

const { Title, Text } = Typography

/**
 * The card both sign-in pages share, laid out like Tracer's: a centred title
 * and prompt, then any notice or error inline, then the step's content. `wide`
 * makes room for identity provider buttons beside the form.
 */
const LoginCard = ({ title, prompt, notice, error, wide = false, children }) => (
  <Flex id="login-page" className="tracer-login" justify="center" align="center">
    <Card className={`login-card${wide ? ' has-providers' : ''}`} data-testid="login-card">
      <Flex vertical={true} gap="large">
        <Flex vertical={true} align="center" gap="small">
          <Title level={3} className="login-title" style={{ margin: 0 }}>
            {title}
          </Title>
          <Text type="secondary" style={{ textAlign: 'center' }}>
            {prompt}
          </Text>
        </Flex>
        {children({
          alerts: (
            <>
              {notice && <Alert type="info" showIcon message={notice} data-testid="login-notice" />}
              {error && <Alert type={error.type} showIcon message={error.message} data-testid="login-error" />}
            </>
          ),
        })}
      </Flex>
    </Card>
  </Flex>
)

LoginCard.propTypes = {
  title: PropTypes.node.isRequired,
  prompt: PropTypes.node,
  notice: PropTypes.node,
  error: PropTypes.shape({ type: PropTypes.string, message: PropTypes.node }),
  wide: PropTypes.bool,
  children: PropTypes.func.isRequired,
}

export default LoginCard
